import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'op-signature-password-modal',
  templateUrl: './signature-password-modal.component.html',
  styleUrls: ['./signature-password-modal.component.sass']
})
export class SignaturePasswordModalComponent {
  @Input() isOpen: boolean = false;
  @Output() onClose = new EventEmitter<void>();
  @Output() onConfirm = new EventEmitter<string>();

  public signaturePassword: string = '';
  public errorMessage: string = '';

  closeModal() {
    this.signaturePassword = '';
    this.errorMessage = '';
    this.onClose.emit();
  }

  confirmPassword() {
    if (!this.signaturePassword) {
      this.errorMessage = '请输入密码';
      return;
    }
    this.errorMessage = '';
    this.onConfirm.emit(this.signaturePassword);
    this.signaturePassword = '';
  }

  setError(message: string) {
    this.errorMessage = message;
  }
} 